import { addClassNamesToElement } from '@lexical/utils'
import {
  $applyNodeReplacement,
  NodeKey,
  TextNode,
  type EditorConfig,
  type LexicalNode,
  type SerializedTextNode
} from 'lexical'

export class EmojiNode extends TextNode {
  constructor(text?: string, key?: NodeKey) {
    super(text, key)
  }

  static getType(): string {
    return 'emoji'
  }

  static clone(node: TextNode): TextNode {
    return new EmojiNode(node.getTextContent(), node.getKey())
  }

  static importJSON(serializedNode: SerializedTextNode): EmojiNode {
    return super.importJSON(serializedNode)
  }

  exportJSON(): SerializedTextNode {
    return {
      ...super.exportJSON(),
      type: EmojiNode.getType()
    }
  }

  createDOM(config: EditorConfig): HTMLElement {
    const dom = super.createDOM(config)
    addClassNamesToElement(dom, config.theme.emoji)
    return dom
  }

  updateDOM(prevNode: this, dom: HTMLElement, config: EditorConfig): boolean {
    return super.updateDOM(prevNode, dom, config)
  }

  isToken() {
    return true
  }

  isUnmergeable(): boolean {
    return true
  }
}

export const $isEmojiNode = (node: LexicalNode | null): node is EmojiNode => {
  return node instanceof EmojiNode
}

export const $createEmojiNode = (text: string = '') => {
  return $applyNodeReplacement(new EmojiNode(text))
}
